import { StandardEvents } from '@shopify/events';

/**
 * When a shopper picks a different variant option (color, style, etc.) on
 * the product page, the main product image updates -- but if they've
 * scrolled past it (e.g. down to the swatches/size grid on mobile), that
 * update happens off-screen and goes unnoticed. Scroll the gallery back
 * into view so the change is actually visible.
 */
document.addEventListener(StandardEvents.productSelect, (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  if (target.closest('product-card') || target.closest('quick-add-dialog')) return;

  const section = target.closest('.shopify-section');
  const gallery = section?.querySelector('media-gallery');
  if (!gallery) return;

  gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
